/*
 * @format
 */

/* eslint no-unused-vars: ["error", { "argsIgnorePattern": "^_" }] */
/* eslint no-continue: 0 */

import { all, call, delay, put, race, take } from 'redux-saga/effects';

import * as types from '../action-types';

// check if the device returned has a location
function* checkDeviceHasLocation() {
  let hasLocation = false;
  while (!hasLocation) {
    const { data } = yield take([types.WEBSOCKET_LIVE_RECEIVED]);
    if (data && data.reason === 'geoUpdateMode') {
      if (data.home.geolocationDevices) {
        // check for geolocation devices that don't have a current zone
        const result = data.home.geolocationDevices.filter(
          i => i.CurrentZone === undefined,
        );
        if (result.length === 0) {
          console.log(
            `all ${data.home.geolocationDevices.length} geolocation devices have confirmed locations`,
          );
          hasLocation = true;
        } else {
          console.log('a device exists with an unconfirmed location', result);
        }
      }
    }
  }
  return hasLocation;
}

function* waitForGeoLocationConfirmation() {
  while (true) {
    const action = yield take(types.GEOLOCATION_LOCATION_CONFIRMATION_PENDING);
    const waitPeriod = 10000; // ideal requested 10 second timeout on this
    const response = yield race({
      response: call(checkDeviceHasLocation, action),
      timeout: delay(waitPeriod),
    });

    if ((response && response.timeout) || response.response === false) {
      yield put({
        ...action,
        type: types.GEOLOCATION_LOCATION_CONFIRMATION_FAILED,
      });
    }
    if (response.response === true) {
      yield put({
        ...action,
        type: types.GEOLOCATION_LOCATION_CONFIRMATION_CLEAR,
      });
    }
  }
}

function* geolocation() {
  yield all([call(waitForGeoLocationConfirmation)]);
}

export default geolocation;
